export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'max'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Box Weight',
        category: ['User', 'Collection'],
        description: 'Storage box weight (g) of the owned version.',
        unit: 'g'
    },
    rules: {
        linked: [],
        legacy: ['version.size.weight']
    }
}
